import request from '@/utils/request'


export function login(account, pwd, googleCode) {
  return request({
    url: '/admin/login',
    method: 'post',
    params: {
      account,
      pwd,
      googleCode
    }
  })
}


export function logout() {
  return request({
    url: '/admin/logOut',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js